import { module } from 'modujs';
import { $html } from '../utils/dom';
import * as focusTrap from 'focus-trap';

export default class AFK extends module {

    static get settings() {
        return {
            DELAY: 90000, // Adjust this value to the desired delay in milliseconds
        };
    }

    constructor(m) {
        super(m);

        this.isActive = true;

        // Events
        this.events = {
            click: {
                'close': 'hide',
            }
        };

        this.resetTimer = this.resetTimer.bind(this);
    }

    init() {
        this.startTimer(); // Initialize the timer

        // Events
        const events = ['mousedown', 'mousemove', 'keypress', 'touchstart'];
        events.forEach(event => {
            document.addEventListener(event, this.resetTimer, true);
        });

        this.focusTrap = focusTrap.createFocusTrap([this.el], {
            onDeactivate: this.hide.bind(this),
            clickOutsideDeactivates: true,
        });
    }

    startTimer() {
        if (this.isActive) {
            clearTimeout(this.time);
            this.time = setTimeout(this.show.bind(this), AFK.settings.DELAY);
        }
    }

    resetTimer() {
        if (!this.isActive) {
            return;
        }

        clearTimeout(this.time);
        this.startTimer();
    }

    show() {
        $html.classList.add('has-AFK-open');
        this.isActive = false;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.focusTrap?.activate()
            })
        })
    }

    hide() {
        $html.classList.remove('has-AFK-open');

        this.isActive = true;
        this.startTimer();
        this.focusTrap?.deactivate()
    }

    destroy() {
        clearTimeout(this.time);

        const events = ['mousedown', 'mousemove', 'keypress', 'touchstart'];
        events.forEach(event => {
            document.removeEventListener(event, this.resetTimer, true);
        });
    }
}
